import { useCustomContext } from "./ContextHook";
import ResponseNotLogged from './ResponseNotLogged';
import GetQueryParam from "../hooks/getQuery";

export default function CheckAuth({ children }: { children: JSX.Element }) {
  const context = useCustomContext();
  const name = GetQueryParam('action');
  const isSelf = GetQueryParam('is-self');

  if (!context.isLogged) {

    if(name ==='success'){
      return (
        <ResponseNotLogged
          success={true}
          title="Thank you for your purchase!"
          description="An email is on its way to the email address you entered with instructions on how you can activate your purchase."
          buttonTitle="Manage my Subscription"
          buttonSubTitle="Back to sale page"
        />
      )
    }
    else{
      return (
        <ResponseNotLogged
          success={false}
          title="Your order has been canceled."
          description=""
          buttonTitle="Back to sale page"
        />
      )

    }

  }
  
  else{
    if(name ==='success'){

      if(isSelf === 'true'){
        return children;
      }
      else{
        return (
          <ResponseNotLogged
          success={true}
          title="Thank you for your purchase!"
          description="An email is on its way to the email address you entered with instructions on how you can activate your purchase."
          buttonTitle="Manage my Subscription"
        />
        )
      }

    }
    else{
      return (
        <ResponseNotLogged
          success={false}
          title="Your order has been canceled."
          description=""
          buttonTitle="Back to sale page"
        />
      )
    }
  }

  }